import { Component } from '@angular/core';

import { AlertController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

import { NotificationType } from 'src/app/enumerates/notification/notification-type';
import { StaffNotification } from 'src/app/models/notification/staff-notification';
import { NotificationToastService } from 'src/app/services/notification/notification-toast.service';

@Component({
    selector: 'app-notification-modal',
    templateUrl: './notification-modal.component.html'
})
export class NotificationModalComponent {
    notification: StaffNotification = {
        type: NotificationType.success,
        title: '',
        description: '',
        icon: '',
        class: ''
    };

    constructor(readonly notificationService: NotificationToastService, private readonly alertController: AlertController, private readonly translateService: TranslateService) {
        notificationService.get().subscribe(
            notification => {
                this.notification = notification;
                void this.showAlertNotification();
            }
        );
    }

    async showAlertNotification(): Promise<void> {
        const alert = await this.alertController.create({
            header: this.translateService.instant(this.notification.title),
            message: this.translateService.instant(this.notification.description),
            buttons: ['OK'],
        });

        await alert.present();
    }
}
